export default "__VITE_ASSET__C7pq0Jub__"